import axios from 'axios';
import { useEffect, useState } from 'react';
import { Button, Card, Col, Row, Table } from 'react-bootstrap';
import { MdEdit, MdShare } from 'react-icons/md';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Pagination from '../../Pagination';
import './HrDashboard.css';

const EvergreenJobs = () => {

  const BASE_API_URL = process.env.REACT_APP_API_URL;
  const location = useLocation();
  const navigate = useNavigate();
  const userName = location.state?.userName;
  const userEmail = location.state?.userEmail;
  const [jobs, setJobs] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(6);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState(' ');
  const [loading, setLoading] = useState(false); // State to manage loading  

  const fetchEverGreenJobs = async () => {
    try {
      setLoading(true);
      const params = {
        userEmail: userEmail,
        page: page,
        size: pageSize,
        sortBy: sortedColumn,
        sortOrder: sortOrder,
      };

      const response = await axios.get(`${BASE_API_URL}/getEverGreenJobsByCompany`, { params });
      setJobs(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (column) => {
    let order = 'asc';
    if (sortedColumn === column) {
      order = sortOrder === 'asc' ? 'desc' : 'asc';
    }
    setSortedColumn(column);
    setSortOrder(order);
  };



  useEffect(() => {
    fetchEverGreenJobs();

  }, [userEmail, page, pageSize, sortedColumn, sortOrder]);


  const [selectedJobSummary, setSelectedJobSummary] = useState(null);
  const handleViewSummary = (summary) => {
    setSelectedJobSummary(summary);
  };

  const handleCloseModal = () => {
    setSelectedJobSummary(null);
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = data.selected;
    setPage(selectedPage);
  };

  const isLastPage = page === totalPages - 1;
  const isPageSizeDisabled = isLastPage;
  const handleShare = (job) => {
    const slug = `${job.jobId}-${job.jobTitle
      .replace(/\s+/g, "-")
      .toLowerCase()}-${job.companyName.replace(/\s+/g, "-").toLowerCase()}`;
    const shareUrl = `${window.location.origin}/browse-jobs/job-details/${slug}`;
    //const shareUrl = `${window.location.origin}/job-details/${jobId}`; // Or however your public job link is structured

    if (navigator.share) {
      navigator.share({
        title: 'Job Opportunity',
        text: 'Check out this job!',
        url: shareUrl,
      })
        .then(() => console.log('Job shared successfully'))
        .catch((error) => console.error('Error sharing', error));
    } else {
      navigator.clipboard.writeText(shareUrl)
        .then(() => {
          Swal.fire({
            title: 'Link Copied!',
            text: 'Job link copied to clipboard. You can share it now.',
            icon: 'success',
            timer: 2000,
            showConfirmButton: false
          });
        })
        .catch(() => {
          Swal.fire({
            title: 'Error',
            text: 'Could not copy link. Please try again.',
            icon: 'error'
          });
        });
    }
  };
  return (
    <div>
      <Row>
        <Col md={12} className="d-flex justify-content-between align-items-center">
          <h2 className="text-start">
            {/*  {!loading && jobs.length === 0 ? (
              <div style={{ color: 'red' }}>
                You have not posted any jobs yet. Post Now
              </div>
            ) : (
              <div></div>
            )}*/}
          </h2>
          <p style={{ color: 'black' }}>An Evergreen Job refers to a position that has no specific deadline and is always open for hiring due to ongoing demand.</p>

          <Button style={{ marginBottom: '10px', marginRight: '20px' }} className='evergreen-job-button'>
            <Link
              to={{
                pathname: '/hr-dashboard/all-jobs/job-form',
                state: { userName, userEmail, jobCategory: 'evergreen' }
              }}
              style={{ textDecoration: 'none', color: 'inherit' }}
              onClick={(e) => {
                e.preventDefault();
                navigate('/hr-dashboard/all-jobs/job-form', { state: { userName, userEmail, jobCategory: 'evergreen' } });
              }}
            >
              Add Evergreen Job
            </Link>
          </Button>
        </Col>
      </Row>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div className="spinner-bubble spinner-bubble-primary m-5" />
          <span>Loading...</span>
        </div>
      ) : jobs.length > 0 ? (
        <div>
          <Card body>
            <div className="table-details-list table-wrapper">
              <Table hover responsive >
                <thead>
                  <tr>
                    <th
                      scope="col"
                      onClick={() => handleSort('jobTitle')}
                      style={{ cursor: 'pointer' }}
                    >
                      Job Title
                      <span>
                        <span
                          style={{
                            color: sortedColumn === 'jobTitle' && sortOrder === 'asc' ? 'black' : 'gray',
                          }}
                        >
                          ↑
                        </span>{' '}
                        <span
                          style={{
                            color: sortedColumn === 'jobTitle' && sortOrder === 'desc' ? 'black' : 'gray',
                          }}
                        >
                          ↓
                        </span>
                      </span>
                    </th>

                    <th
                      scope="col"
                      onClick={() => handleSort('jobType')}
                      style={{ cursor: 'pointer' }}
                    >
                      Job Type
                      <span>
                        <span
                          style={{
                            color: sortedColumn === 'jobType' && sortOrder === 'asc' ? 'black' : 'gray',
                          }}
                        >
                          ↑
                        </span>{' '}
                        <span
                          style={{
                            color: sortedColumn === 'jobType' && sortOrder === 'desc' ? 'black' : 'gray',
                          }}
                        >
                          ↓
                        </span>
                      </span>
                    </th>

                    <th
                      scope="col"
                      onClick={() => handleSort('skills')}
                      style={{ cursor: 'pointer' }}
                    >
                      Skills
                      <span>
                        <span
                          style={{
                            color: sortedColumn === 'skills' && sortOrder === 'asc' ? 'black' : 'gray',
                          }}
                        >
                          ↑
                        </span>{' '}
                        <span
                          style={{
                            color: sortedColumn === 'skills' && sortOrder === 'desc' ? 'black' : 'gray',
                          }}
                        >
                          ↓
                        </span>
                      </span>
                    </th>

                    <th
                      scope="col"
                      onClick={() => handleSort('salary')}
                      style={{ cursor: 'pointer' }}
                    >
                      Salary
                      <span>
                        <span
                          style={{
                            color: sortedColumn === 'salary' && sortOrder === 'asc' ? 'black' : 'gray',
                          }}
                        >
                          ↑
                        </span>{' '}
                        <span
                          style={{
                            color: sortedColumn === 'salary' && sortOrder === 'desc' ? 'black' : 'gray',
                          }}
                        >
                          ↓
                        </span>
                      </span>
                    </th>

                    <th scope="col">Job Description</th>

                    <th scope="col">Update Job</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {jobs.map((job) => (
                    <tr key={job.id}>
                      <td>
                        <a onClick={() => handleViewSummary(job.jobsummary)}>{job.jobTitle}</a>
                      </td>
                      <td>{job.jobType}</td>
                      <td>{job.skills}</td>
                      <td>{job.salary}</td>
                      <td>
                        <Button
                          variant="secondary"
                          className="description btn-rounded"
                          onClick={() => handleViewSummary(job.jobsummary)}
                        >
                          Summary
                        </Button>
                      </td>
                      <td>
                        <span
                          className="cursor-pointer text-success me-2 update"
                          onClick={() =>
                            navigate('/hr-dashboard/evergreen-jobs/update', {
                              state: {
                                userName,
                                userEmail,
                                jobId: job.jobId,
                                currentPage: page,
                                currentPageSize: pageSize,
                              },
                            })
                          }
                        >
                          <MdEdit size={18} className="text-success" />
                        </span>
                      </td>
                      <td>
                        <Button
                          variant='success' onClick={() => handleShare(job)}>
                          {/* <MdShare size={18}/> Share */} Share
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <Pagination
              page={page}
              pageSize={pageSize}
              totalPages={totalPages}
              handlePageSizeChange={handlePageSizeChange}
              isPageSizeDisabled={isPageSizeDisabled}
              handlePageClick={handlePageClick}
            />
          </Card>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center">
          <span>No jobs available</span>
        </div>
      )}

      {/* {selectedJobSummary && (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Job Summary</h5>
              </div>
              <div className="modal-body">
                <pre className="job-details-text">{selectedJobSummary}</pre>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal} onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleCloseModal();
                  }
                }}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
      {selectedJobSummary && (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
          <div className="modal-dialog" role="document" > {/*style={{ minWidth: '300px', maxWidth: '80%' }} */}
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Job Summary</h5>
              </div>
              <div className="modal-body" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <pre className="job-details-text">{selectedJobSummary}</pre>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseModal}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      handleCloseModal();
                    }
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>

  );
};

export default EvergreenJobs;
